import { DDSBodyText, DDSHeadlineText, DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import { t } from "@web-monorepo/i18n/macro";
import styles from "./WelcomeCallout.module.css";

type WelcomeCalloutProps = {
  dismissWelcomeNux?: VoidFunction;
};

export default function WelcomeCallout({ dismissWelcomeNux }: WelcomeCalloutProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <DDSHeadlineText as="h3" level="sm">
          {t`Welcome to Toolkit!`}
        </DDSHeadlineText>
        <DDSIconButton
          data-name="welcome_callout:dismiss"
          aria-label={t`Dismiss welcome message`}
          tooltip={{ content: t`Dismiss welcome message`, dataName: "welcome_callout:dismiss:tooltip" }}
          variant="transparent"
          onClick={dismissWelcomeNux}
        >
          <IconX />
        </DDSIconButton>
      </div>
      <div className={styles.content}>
        <DDSBodyText className={styles.paragraph}>
          {t`All your favorite classroom tools are now in one place.`}
        </DDSBodyText>
        <DDSBodyText className={styles.paragraph}>
          {t`Start a tool from your phone and see it projected in front of the class!`}
        </DDSBodyText>
      </div>
    </div>
  );
}
